import {lazyWithRetry} from '../../../lazyWithRetry/lazyWithRetry';

export const LazyCampaignStatsHighlights = lazyWithRetry(() => import('./CampaignStatsHighlights'));
